export enum InternalUserPermission {
    // ── Subscription ─────────────────────────────────────────────
    VIEW_SUBSCRIPTION_DETAILS = 'view_subscription_details',
    VIEW_COST_PER_MESSAGE = 'view_cost_per_message',
    VIEW_SUBSCRIPTION_PRICE = 'view_subscription_price',
    DEACTIVATE_SUBSCRIPTION = 'deactivate_subscription',
    NEW_SUBSCRIPTION = 'new_subscription',
    VIEW_ONE_TIME_CHARGES = 'view_one_time_charges',
    STOP_PACKAGES = 'stop_packages',
    CREATE_PACKAGES = 'create_packages',
    TEST_SUBSCRIPTION = 'test-subscription',
    COMPLIMENTARY_SUBSCRIPTION = 'complimentary_subscription',

    // ── Billing ───────────────────────────────────────────────────
    VIEW_BILLING_INVOICE_PRICES = 'view_billing_invoice_prices',
    VIEW_BILLING_ENTITIES = 'view_billing_entities',
    MARK_PACKAGES_PAID = 'mark_packages_paid',

    // ── Invoices ──────────────────────────────────────────────────
    VIEW_INVOICES = 'view-invoices',

    // ── Grace Period ─────────────────────────────────────────────
    VIEW_GRACE_PERIOD = 'view_grace_period',
    MANAGE_GRACE_PERIOD = 'manage_grace_period',

    // ── Notes ─────────────────────────────────────────────────────
    VIEW_CS_NOTES = 'view_cs_notes',
    EDIT_CS_NOTES = 'edit_cs_notes',
    VIEW_DEV_NOTES = 'view_dev_notes',
    EDIT_DEV_NOTES = 'edit_dev_notes',
    VIEW_SALES_NOTES = 'view_sales_notes',
    EDIT_SALES_NOTES = 'edit_sales_notes',

    // ── Management ────────────────────────────────────────────────
    CREATE_TENANT = 'create_tenant',
    CREATE_NEW_BUSINESS = 'create_new_business',

    // ── Tenant listing ────────────────────────────────────────────
    MANAGE_TENANT_TAGS = 'manage_tenant_tags',
    BULK_EDIT_TENANTS = 'bulk_edit_tenants',

    // ── Superset ──────────────────────────────────────────────────
    MANAGE_SUPERSET_PRESETS = 'manage_superset_presets',

    // ── Help videos ───────────────────────────────────────────────
    UPLOAD_HELP_VIDEOS = 'upload_help_videos',
    APPROVE_HELP_VIDEOS = 'approve_help_videos',
    EDIT_HELP_VIDEO_CATALOG = 'edit_help_video_catalog',

    // ── Email validation credits ──────────────────────────────────
    VIEW_EMAIL_VALIDATION_CREDITS = 'view_email_validation_credits',
    MANAGE_EMAIL_VALIDATION_CREDITS = 'manage_email_validation_credits',
}
